import React, { Component } from 'react'
import { CallToAction } from '@scentregroup/ui'
import PropTypes from 'prop-types'
import style from './index.scss'

class ShowMore extends Component {
  state = {
    hasClicked: false,
  }
  showAll = () => {
    this.setState({
      hasClicked: true,
    })
  }

  render() {
    const { children, buttonText, minItems } = this.props
    const { hasClicked } = this.state
    const items = hasClicked && children ? children.length : minItems

    return (
      // Need to check minItems props here to ensure the parent component  needs to use it
      <React.Fragment>
        {minItems ? children.slice(0, items) : children}
        {minItems && !hasClicked && children.length >= items && (
          // Hide the button if there are less children than minItems
          <div className={style.showMoreWrapper}>
            <CallToAction data-test-id="show-more" onClick={this.showAll}>
              {buttonText}
            </CallToAction>
          </div>
        )}
      </React.Fragment>
    )
  }
}

ShowMore.propTypes = {
  minItems: PropTypes.number,
  children: PropTypes.array,
  buttonText: PropTypes.string,
}

ShowMore.defaultProps = {
  minItems: 0,
  buttonText: 'See more',
}

export default ShowMore
